import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const mapDisplayDefaultVariants = {}
const mapDisplayCompoundVariants = []

const mapDisplaySlotNames = [
  [
    "root",
    "map-display__root"
  ],
  [
    "mapWrapper",
    "map-display__mapWrapper"
  ],
  [
    "contentWrapper",
    "map-display__contentWrapper"
  ]
]
const mapDisplaySlotFns = /* @__PURE__ */ mapDisplaySlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, mapDisplayDefaultVariants, getSlotCompoundVariant(mapDisplayCompoundVariants, slotName))])

const mapDisplayFn = memo((props = {}) => {
  return Object.fromEntries(mapDisplaySlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const mapDisplayVariantKeys = []
const getVariantProps = (variants) => ({ ...mapDisplayDefaultVariants, ...compact(variants) })

export const mapDisplay = /* @__PURE__ */ Object.assign(mapDisplayFn, {
  __recipe__: false,
  __name__: 'mapDisplay',
  raw: (props) => props,
  variantKeys: mapDisplayVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, mapDisplayVariantKeys)
  },
  getVariantProps
})